export const FeatureFlags = {
  BOOK_NOW_NEWSLETTER_SIGNUP: 'book-now-newsletter-signup',
  INSTANT_BOOKING: 'instant-booking'
} as const;

export type FeatureFlagKey = typeof FeatureFlags[keyof typeof FeatureFlags];
